import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const MATICX_URL = 'https://universe.staderlabs.com/polygon/apy'
const ETHX_URL = 'https://universe.staderlabs.com/eth/apy'
const ethX = 'Stader ETHx::ETHx'

export const maticxFetcher: YieldFetcher = {
  label: 'MATICX',
  fetch: async () => {
    const res = await fetch(MATICX_URL).then((r) => r.json())
    return { MATICX: Number(res.value) * 0.9 }
  },
}

export const ethxFetcher: YieldFetcher = {
  label: 'ETHX',
  fetch: async () => {
    const res = await fetch(ETHX_URL).then((r) => r.json())
    return { [ethX]: apyToAprPercent(res.value) }
  },
}
